import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  inject,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@i18n';
import { QMSanitiseDirective } from '@qm';
import { TextInputComponent } from '../../../input/components/text-input/text-input.component';
import { FormFieldComponent } from '../../../layout/components/form-field/form-field.component';
import { SelectComponent } from '../../../select/components/select/select.component';
import { BaseFormGroupComponent } from '../../../shared/components/base-form-group/base-form-group.component';
import { FormOption } from '../../../shared/models/form-option.interface';
import { FormAddress } from '../../models/form-address/form-address.interface';
import { ADDRESS_PROVINCE_FORM_OPTIONS } from '../../tokens/address-province-form-options.token';

@Component({
  selector: 'app-form-manual-address',
  templateUrl: './manual-address.component.html',
  styleUrl: './manual-address.component.scss',
  providers: [
    {
      provide: BaseFormGroupComponent,
      useExisting: forwardRef(() => ManualAddressComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormFieldComponent,
    QMSanitiseDirective,
    ReactiveFormsModule,
    SelectComponent,
    TextInputComponent,
    TranslatePipe,
  ],
  standalone: true,
})
export class ManualAddressComponent extends BaseFormGroupComponent<FormAddress> {
  readonly addressProvinceFormOptions = inject<FormOption[] | undefined>(
    ADDRESS_PROVINCE_FORM_OPTIONS,
  );
}
